import { ReactElement } from 'react';
import { AddRounded, CheckCircleRounded } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

// Styles
import styles from '../TypeaheadMulti.module.scss';

// Types
import { ILabelType } from '../Typeahead';

const StyledCheckCircleRounded = styled(CheckCircleRounded)({
  border: 0,
  borderRadius: '50%',
  boxShadow: '1px 3px 8px 2px #00000019',
  color: '#82bc00',
  height: '1.5rem',
  marginRight: '0.875rem',
  minWidth: '1.5rem',
  width: '1.5rem',
  '.site-ja &': {
    color: '#00aea9',
  },
});

const StyledAddRounded = styled(AddRounded)({
  color: '#82bc00',
  marginRight: '0.875rem',
  '.site-ja &': {
    color: '#00aea9',
  },
});

interface IProps {
  option: ILabelType;
  selected: boolean;
}

export const InputOption = (props: IProps): ReactElement => {
  const { option, selected } = props;
  const { label, name, description } = option;

  return (
    <>
      {selected ? <StyledCheckCircleRounded /> : <StyledAddRounded />}
      <div className={styles['option-content']}>
        <div className={styles['option-content-label']}>{label || name}</div>
        <div className={styles['option-content-caption']}>{description}</div>
      </div>
    </>
  );
};
